/**
 * MainPanel component with caching data.
 *
 * @author Roman Stoian <r.stoyan@infomir.com>.
 */

/* eslint no-path-concat: 0 */
/* eslint complexity: 0 */
/* eslint max-statements: 0 */
/* eslint max-lines-per-function: 0 */

'use strict';

//TODO inherit MainPanel
var Component = require('spa-component'),
    keys      = require('spa-keys');

/**
 * Mouse click event.
 *
 * @event module:stb/ui/grid~MainPanel#click:item
 *
 * @type {Object}
 * @property {Element} $item clicked HTML item
 * @property {Event} event click event data
 */


/**
 * Cache grid implementation.
 *
 *
 * @constructor
 * @extends Component
 *
 * @param {Object}   config - init parameters (all inherited from the parent)
 * @param {Function} [config.render] - method to build item content
 * @param {Function} [config.createLine] - method to create new grid line
 * @param {boolean}  [config.cycleX=true] - allow or not to jump to the opposite side of line when there is nowhere to go next
 * @param {boolean}  [config.cycleY=true] - allow or not to jump to the opposite side of column when there is nowhere to go next
 * @param {Function} config.getter - method to get data for cache
 * @param {Object}   [config.request={}] - request params for getter
 * @param {number}   config.sizeY - grid columns count
 * @param {number}   config.sizeX - grid rows count
 * @param {number}   [config.bufferSize=3] - amount of buffered items
 * @param {number}   [config.focusIndex] - list item index to make item focused (move view window to this position)
 * @param {boolean}  [config.emptyLine=true] - need add empty items in before and after list data
 * @param {number}   [config.focusPosition] - focus line index
 *
 */
function Grid ( config ) {
    // current execution context
    var self = this;

    console.assert(typeof this === 'object', 'must be constructed via new');

    // sanitize
    config = config || {};

    if ( DEVELOP ) {
        if ( typeof config !== 'object' ) { throw new Error(__filename + ': wrong config type'); }
        // init parameters checks
        if ( config.className && typeof config.className !== 'string' ) { throw new Error(__filename + ': wrong or empty config.className'); }
        //if ( config.navigate  && typeof config.navigate  !== 'function' ) { throw new Error(__filename + ': wrong config.navigate type'); }
    }

    /**
     * List of DOM elements representing the component cells.
     * Necessary for navigation calculations.
     *
     * @type {Element[][]}
     */
    this.bufferBefore = [];
    this.mainList = [];
    this.bufferAfter = [];

    this.loadData = false;

    this.$focusLine = null;
    this.$focusItem = null;


    /**
     * Component data to visualize.
     *
     * @type {Array[]}
     */
    this.data = [];

    /**
     * Allow or not to jump to the opposite side of line when there is nowhere to go next.
     *
     * @type {boolean}
     */
    this.cycleX = false;

    /**
     * Allow or not to jump to the opposite side of column when there is nowhere to go next.
     *
     * @type {boolean}
     */
    this.cycleY = false;

    this.emptyLine = false;
    this.bufferSize = 0;

    config.$body = document.createElement('div');
    config.$body.className = 'body';

    // parent constructor call
    Component.call(this, config);

    if ( config.title ) {
        this.$title = document.createElement('div');
        this.$title.className = 'title';
        this.$node.appendChild(this.$title);
    }
    this.$node.appendChild(this.$body);

    this.$noData = document.createElement('div');
    this.$noData.className = 'noData hidden';
    this.$node.appendChild(this.$noData);

    // component setup
    this.init(config);
    this.inFocus = false;

    this.addListener('focus', function () {
        self.inFocus = true;
        if ( self.$focusItem ) {
            if ( self.events['focus:item'] ) {
                self.emit('focus:item', {$prev: null, $curr: self.$focusItem});
            }
        }
    });

    this.addListener('blur', function () {
        self.inFocus = false;
    });
}


// inheritance
Grid.prototype = Object.create(Component.prototype);
Grid.prototype.constructor = Grid;

// set component name
Grid.prototype.name = 'mag-component-cache-grid';


/**
 * Fill the given cell with data.
 * $item.data can contain the old data (from the previous render).
 *
 * @param {Element} $item - item DOM link
 * @param {*} data - associated with this item data
 */
Grid.prototype.renderItemDefault = function ( $item, data ) {
    if ( DEVELOP ) {
        if ( arguments.length !== 2 ) { throw new Error(__filename + ': wrong arguments number'); }
        if ( !($item instanceof Element) ) { throw new Error(__filename + ': wrong $item type'); }
    }

    $item.innerText = data.value;
};

/**
 * Create line.
 * $item.data can contain the old data (from the previous render).
 *
 * @param {number} index - array index
 * @param {Object} data - associated with this item data
 *
 * @return {HTMLElement} ready item
 */
Grid.prototype.createLineDefault = function ( index, data ) {
    var $item = document.createElement('div');

    $item.className = 'line';
    $item.index = index;
    $item.data = data;

    return $item;
};


/**
 * Method to build each grid cell content.
 * Can be redefined to provide custom rendering.
 *
 * @type {function}
 */
Grid.prototype.renderItem = Grid.prototype.renderItemDefault;

Grid.prototype.createItem = function ( index ) {
    var item = document.createElement('div');

    item.className = 'item';
    item.index = index;

    return item;
};

/**
 * Method to build each grid cell content.
 * Can be redefined to provide custom rendering.
 *
 * @type {function}
 */
Grid.prototype.createLine = Grid.prototype.createLineDefault;

/**
 * List of all default event callbacks.
 *
 * @type {Object.<string, function>}
 */
Grid.prototype.defaultEvents = {
    /**
     * Default method to handle mouse wheel events.
     *
     * @param {Event} event - generated event
     */
    mousewheel: function ( event ) {
        // scrolling by Y axis
        if ( event.wheelDeltaY ) {
            this.move(event.wheelDeltaY > 0 ? keys.up : keys.down);
        }

        // scrolling by X axis
        if ( event.wheelDeltaX ) {
            this.move(event.wheelDeltaX > 0 ? keys.left : keys.right);
        }
    },

    /**
     * Default method to handle keyboard keydown events.
     *
     * @param {Object} event - generated event
     */
    keydown: function ( event ) {
        switch ( event.code ) {
            case keys.up:
            case keys.down:
            case keys.right:
            case keys.left:
                // cursor move only on arrow keys
                event.stop = true;
                this.move(event.code);
                break;
            case keys.enter:
                event.stop = true;
                // there are some listeners
                if ( this.events['click:item'] ) {
                    // notify listeners
                    this.emit('click:item', {$item: this.$focusItem, event: event});
                }
                break;
        }
    }
};


/**
 * Make all the data items identical.
 * Wrap to objects if necessary.
 *
 * @param {Array} data - incoming array
 * @return {Array} reworked - incoming data
 */
function normalize ( data ) {
    var index, item;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) {
            throw new Error(__filename + ': wrong arguments number');
        }
        if ( !Array.isArray(data) ) {
            throw new Error(__filename + ': wrong data type');
        }
    }

    // rows
    for ( index = 0; index < data.length; index++ ) {
        // cell value
        item = data[index];
        // primitive value
        if ( typeof item !== 'object' ) {
            // wrap with defaults
            item = data[index] = {
                value: data[index]
            };
        }

        if ( DEVELOP ) {
            //if ( !('value' in item) ) { throw new Error(__filename + ': field "value" is missing'); }
            if ( ('mark' in item) && Boolean(item.mark) !== item.mark ) {
                throw new Error(__filename + ': item.mark must be boolean');
            }
        }
    }

    return data;
}


/**
 * Init or re-init of the component inner structures and HTML.
 *
 * @param {Object} config - init parameters (subset of constructor config params)
 */
Grid.prototype.init = function ( config ) {
    var self = this;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) { throw new Error(__filename + ': wrong arguments number'); }
        if ( typeof config !== 'object' ) { throw new Error(__filename + ': wrong config type'); }
    }

    // custom render method
    if ( config.render ) {
        self.renderItem = config.render;
    }

    // custom render method
    if ( config.createLine ) {
        self.createLine = config.createLine;
    }

    // apply cycle behaviour
    if ( config.cycleX !== undefined ) {
        this.cycleX = config.cycleX;
    }
    if ( config.cycleY !== undefined ) {
        this.cycleY = config.cycleY;
    }


    if ( config.sizeX && config.sizeY ) {
        if ( DEVELOP ) {
            if ( !config.sizeX || !config.sizeY ) {
                throw new Error(__filename + ': wrong grid data size');
            }
        }

        this.sizeX = config.sizeX;
        this.sizeY = config.sizeY;
    }

    if ( config.bufferSize !== undefined ) {
        if ( DEVELOP ) {
            if ( +config.bufferSize !== config.bufferSize ) {
                throw new Error(__filename + ': config.bufferSize must be a number');
            }
            if ( config.bufferSize <= 0 ) {
                throw new Error(__filename + ': config.bufferSize should be positive');
            }
        }

        // apply
        this.bufferSize = config.bufferSize;
    }

    if ( config.emptyLine !== undefined ) {
        this.emptyLine = config.emptyLine;
    }

    if ( config.events ) {
        // apply all given events
        Object.keys(config.events).forEach(function ( name ) {
            self.events[name] = null;
            self.addListener(name, config.events[name]);
        });
    }

    if ( config.translate ) {
        this.translate = config.translate;
    }

    if ( config.emptyLine !== undefined ) {
        this.emptyLine = config.emptyLine;
    }

    if ( config.noData ) {
        this.$noData.innerText = config.noData;
    }

    this.getter = config.getter;
    this.config = config.request || {};

    this.size = this.sizeX * this.sizeY;
    this.viewIndex = null;
    this.lastViewindex = 0;
    this.maxCount = 0;

    /**
     * Current navigation map horizontal position.
     *
     * @type {number}
     */
    this.focusX = 0;

    /**
     * Current navigation map vertical position.
     *
     * @type {number}
     */
    this.focusY = 0;

    if ( !this.getter ) {

        return;
    }

    if ( this.$title && config.title ) {
        this.$title.innerText = config.title;
    }

    if ( config.focusIndex === undefined ) {
        // go to the first page
        this.initView(0);
    } else {
        if ( DEVELOP ) {
            if ( +config.focusIndex !== config.focusIndex ) {
                throw new Error(__filename + ': config.focusIndex must be a number');
            }
            if ( config.focusIndex < 0 ) {
                throw new Error(__filename + ': config.focusIndex should be positive');
            }
        }

        // jump to the necessary item
        this.focusIndex(config.focusIndex);
    }
};

/**
 * Set the given item focused by item index.
 *
 * @param {number} index - item data index
 */
Grid.prototype.focusIndex = function ( index ) {
    var viewIndex = this.viewIndex || 0;

    if ( DEVELOP ) {
        if ( +index !== index ) {
            throw new Error(__filename + ': index must be a number');
        }
        if ( index < 0 ) {
            throw new Error(__filename + ': index should be positive');
        }
    }

    this.initView(viewIndex);

    //TODO: may be in future it will be need
    // if ( index >= this.data.length ) {
    //     this.initView(0, function () {
    //         self.focusLine(self.$body.firstChild);
    //     });
    // } else if ( index >= viewIndex + this.focusPosition ) {
    //     viewIndex = index - this.focusPosition;
    //     if ( viewIndex + this.size < this.data.length ) {
    //         this.initView(viewIndex, function () {
    //             self.focusLine(self.mainList[self.focusPosition]);
    //         });
    //     } else {
    //         tempIndex = this.size - this.data.length + index;//7-7+6
    //         viewIndex = this.data.length - this.size;
    //         if ( this.hasEmptyItems ) {
    //             tempIndex--;
    //             viewIndex++;
    //         }
    //         this.initView(viewIndex, function () {
    //             self.focusLine(self.mainList[tempIndex]);
    //         });
    //     }
    //
    // } else {
    //     tempIndex = index - this.focusPosition;
    //     if ( tempIndex < 0 ) {
    //         this.initView(0, function () {
    //             self.focusLine(self.mainList[index]);
    //         });
    //     } else {
    //         this.initView(tempIndex, function () {
    //             self.focusLine(self.mainList[self.focusPosition]);
    //         });
    //     }
    // }
};


/**
 * Get data and fill row.
 *
 * @param {Object} row - row to render
 */
Grid.prototype.fillRow = function ( row ) {
    var self = this,
        index = row.index * this.sizeX;

    this.loadData = true;
    this.config.offset = index;
    this.config.limit = this.sizeX;

    this.getter(function ( error, data ) {
        var $item, ix;

        if ( error ) {
            if ( self.events['data:error'] ) {
                self.emit('data:error', error);
            }
            // self.fillRow(row);
            self.loadData = false;

            return;
        }
        data = normalize(data);
        for ( ix = 0; ix < self.sizeX; ix++ ) {
            if ( ix < data.length ) {
                $item = self.createItem(index + ix);
                self.renderItem($item, data[ix]);
                row.appendChild($item);
            }
        }
        self.loadData = false;
    }, this.config);
};


/**
 * Init the visible window.
 *
 * @param {number} viewIndex - start position to render
 *
 * @fires module:stb/ui/list~List#move:view
 *
 * @return {boolean} init state
 */
Grid.prototype.initView = function ( viewIndex ) {
    var self = this,
        count = 0;

    if ( DEVELOP ) {
        if ( +viewIndex !== viewIndex ) {
            throw new Error(__filename + ': viewIndex must be a number');
        }
        if ( viewIndex < 0 ) {
            throw new Error(__filename + ': viewIndex should be more than zero');
        }
    }

    function fill ( error, data, maxCount ) {
        var index = 0,
            before = self.viewIndex - self.startIndex,
            size = self.sizeY - (self.emptyLine ? 1 : 0),
            lines = Math.ceil(data.length / self.sizeX),
            item, row,
            indexX, indexY;

        self.data = [];
        if ( error ) {
            if ( self.events['data:error'] ) {
                self.emit('data:error', error);
            }
            self.$title.classList.add('hidden');
            self.$body.classList.add('hidden');
            self.$noData.classList.remove('hidden');

            return;
        }

        data = normalize(data);
        self.data = data;
        self.maxCount = maxCount;
        self.lastViewindex = Math.ceil(maxCount / self.sizeX) - self.sizeY + ( self.emptyLine ? 1 : 0 );

        for ( indexY = 0; indexY < lines; indexY++ ) {
            row = self.createLine(indexY);
            self.$body.appendChild(row);
            if ( indexY < before ) {
                self.bufferBefore.push(row);
                row.classList.add('hidden');
            } else if ( indexY < size ) {
                self.mainList.push(row);
            } else {
                self.bufferAfter.push(row);
                row.classList.add('hidden');
            }
            for ( indexX = 0; indexX < self.sizeX; indexX++ ) {
                if ( index < data.length ) {
                    item = self.createItem(self.startIndex + index);
                    row.appendChild(item);
                    self.renderItem(item, data[index]);
                }
                index++;
            }
        }

        if ( data.length ) {
            self.focusItem(self.focusX, self.focusY);
            self.$noData.classList.add('hidden');
            self.$title.classList.remove('hidden');
            self.$body.classList.remove('hidden');
        } else {
            self.$title.classList.add('hidden');
            self.$body.classList.add('hidden');
            self.$noData.classList.remove('hidden');
        }
        if ( self.events['data:ready'] ) {
            /**
             * Provider get new data and reinit grid.
             *
             * @event module:stb/ui/grid~MainPanel#data:ready
             */
            self.emit('data:ready');
        }
    }

    if ( this.viewIndex === viewIndex ) {
        return true;
    }

    while ( this.$body.firstChild ) {
        this.$body.removeChild(this.$body.firstChild);
    }

    this.viewIndex = viewIndex || 0;

    this.startIndex = this.viewIndex - this.bufferSize;
    if ( this.startIndex < 0 ) {
        count = Math.abs(this.startIndex);
        this.startIndex = 0;
    } else {
        count = this.bufferSize;
    }

    this.bufferBefore = [];
    this.mainList = [];
    this.bufferAfter = [];

    this.$node.classList.remove('emptyAfter');
    this.$node.classList.remove('noEmptyBefore');

    count = this.size + (this.sizeX * (count + this.bufferSize));

    this.config.offset = this.startIndex * this.sizeX;
    this.config.limit = count;
    this.getter(fill, this.config);

    return false;
};


/**
 * Default translate function.
 *
 * @param {Array} data - data to translate
 *
 * @return {Array} data to use as grid data
 */
Grid.prototype.defaultTranslate = function ( data ) {
    var result = [],
        idxY, idxX, arr;

    for ( idxY = 0; idxY < this.sizeY; idxY++ ) {
        arr = [];
        for ( idxX = 0; idxX < this.sizeX; idxX++ ) {
            arr[idxX] = data[(idxY * this.sizeX) + idxX];
        }
        result[idxY] = arr;
    }

    return result;
};


/**
 * Method to translate given array to array adapted to use as grid data.
 * Can be redefined to provide custom translate.
 *
 * @type {function}
 */
Grid.prototype.translate = Grid.prototype.defaultTranslate;


/**
 * Move focus to the given direction.
 *
 * @param {number} direction - arrow key code
 *
 * @fires module:stb/ui/grid~MainPanel#cycle
 * @fires module:stb/ui/grid~MainPanel#overflow
 * @fires module:stb/ui/grid~MainPanel#data:get
 * @fires module:stb/ui/grid~MainPanel#data:ready
 * @fires module:stb/ui/grid~MainPanel#data:error
 *
 * @return {boolean} done move correctly
 */
Grid.prototype.move = function ( direction ) {
    var $item, lastIndex,
        state = false,
        focusX   = this.focusX,
        focusY   = this.focusY;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) { throw new Error(__filename + ': wrong arguments number'); }
        if ( +direction !== direction ) { throw new Error(__filename + ': direction must be a number'); }
    }

    if ( this.loadData ) {
        return false;
    }
    // shift till full stop
    // arrow keys
    switch ( direction ) {
        case keys.up:
            if ( this.viewIndex > 0 ) {
                if ( this.bufferBefore.length ) {
                    this.viewIndex--;
                    lastIndex = this.bufferBefore[0].index;
                    lastIndex--;

                    if ( this.emptyLine ) {
                        this.$node.classList.remove('emptyAfter');
                    }
                    $item = this.bufferBefore.pop();
                    $item.classList.remove('hidden');
                    this.mainList.unshift($item);

                    if ( this.mainList.length > this.sizeY ) {
                        $item = this.mainList.pop();
                        this.bufferAfter.unshift($item);
                        $item.classList.add('hidden');
                    }

                    if ( this.bufferAfter.length > this.bufferSize ) {
                        $item = this.bufferAfter.pop();
                        this.$body.removeChild($item);
                    }

                    if ( lastIndex >= 0 ) {
                        $item = this.createLine(lastIndex);
                        $item.classList.add('hidden');
                        this.$body.insertBefore($item, this.$body.firstChild);
                        this.bufferBefore.unshift($item);
                        this.fillRow($item);
                    }
                    this.focusItem(focusX, focusY);
                    state = true;
                } else {
                    if ( this.emptyLine ) {
                        if ( this.mainList.length >= this.sizeY  ) {
                            $item = this.mainList.pop();
                            this.bufferAfter.unshift($item);
                            $item.classList.add('hidden');
                        }
                        this.$node.classList.remove('noEmptyBefore');
                    }
                    if ( focusY > 0 ) {
                        focusY--;
                        this.focusItem(focusX, focusY);
                        state = true;
                    }
                }
            } else if ( focusY > 0 ) {
                if ( this.emptyLine ) {
                    this.$node.classList.remove('noEmptyBefore');
                    if ( this.mainList.length >= this.sizeY  ) {
                        $item = this.mainList.pop();
                        this.bufferAfter.unshift($item);
                        $item.classList.add('hidden');
                    }
                }
                focusY--;
                this.focusItem(focusX, focusY);
                state = true;
            } else {
                if ( this.cycleY ) {
                    this.move(keys.end);
                } else {
                    state = false;
                }

                if ( this.events['overflow'] ) {
                    // notify listeners
                    this.emit('overflow', {direction: direction, cycle: this.cycleY});
                }
            }
            break;
        case keys.down:
            if ( this.viewIndex < this.lastViewindex - 1 ) {
                this.$node.classList.add('noEmptyBefore');

                if ( this.bufferAfter.length ) {
                    lastIndex = this.bufferAfter[this.bufferAfter.length - 1].index;
                    lastIndex++;
                    // if ( this.bufferAfter[0].children.length === 0 ) {
                    //
                    //     return false;
                    // }
                    $item = this.bufferAfter.shift();
                    this.mainList.push($item);
                    $item.classList.remove('hidden');
                }

                if ( this.mainList.length > this.sizeY ) {
                    this.viewIndex++;
                    $item = this.mainList.shift();
                    $item.classList.add('hidden');
                    this.bufferBefore.push($item);
                }

                if ( this.bufferBefore.length > this.bufferSize ) {
                    $item = this.bufferBefore.shift();
                    this.$body.removeChild($item);
                }

                if ( lastIndex < this.lastViewindex + this.sizeY - 1 ) {
                    $item = this.createLine(lastIndex);
                    $item.classList.add('hidden');
                    this.$body.appendChild($item);
                    this.fillRow($item);
                    this.bufferAfter.push($item);
                } else if ( this.emptyLine ) {
                    this.$node.classList.add('emptyAfter');
                }
                if ( focusY < this.mainList.length - 2 ) {
                    focusY++;
                }
                state = true;
                this.focusItem(focusX, focusY);
            } else if ( focusY < this.mainList.length - 1 ) {
                if ( this.mainList.length >= this.sizeY ) {
                    this.viewIndex++;
                    $item = this.mainList.shift();
                    $item.classList.add('hidden');
                    this.bufferBefore.push($item);

                    if ( this.bufferBefore.length > this.bufferSize ) {
                        $item = this.bufferBefore.shift();
                        this.$body.removeChild($item);
                    }
                } else {
                    if ( this.bufferAfter.length ) {
                        $item = this.bufferAfter.shift();
                        this.mainList.push($item);
                        $item.classList.remove('hidden');
                    }
                    focusY++;
                    this.$node.classList.add('noEmptyBefore');
                }
                state = true;
                this.focusItem(focusX, focusY);
            } else {
                if ( this.cycleY ) {
                    this.move(keys.home);
                } else {
                    state = false;
                }

                if ( this.events['overflow'] ) {
                    // notify listeners
                    this.emit('overflow', {direction: direction, cycle: this.cycleY});
                }
            }
            break;

        case keys.right:
            if ( focusX < this.$focusLine.children.length - 1 ) {
                // can go one step right
                focusX++;
                this.focusItem(focusX, focusY);
                state = true;
            } else if ( this.cycleX ) {
                // jump to the first column
                focusX = 0;
                this.focusItem(focusX, focusY);
                state = true;
                if ( this.events['overflow'] ) {
                    this.emit('overflow', {direction: direction, cycle: this.cycleX});
                }
            } else {
                this.focusX = 0;
                state = this.move(keys.down);
                if ( !state ) {
                    this.focusX = focusX;
                }
            }
            break;
        case keys.left:
            if ( focusX > 0 ) {
                // can go one step left
                focusX--;
                this.focusItem(focusX, focusY);
                state = true;
            } else if ( this.cycleX ) {
                focusX = this.$focusLine.children.length - 1;
                // jump to the last column
                this.focusItem(focusX, focusY);
                state = true;
                if ( this.events['overflow'] ) {
                    this.emit('overflow', {direction: direction, cycle: this.cycleX});
                }
            } else {
                this.focusX = this.sizeX - 1;
                state = this.move(keys.up);
                if ( !state ) {
                    this.focusX = focusX;
                }
            }
            break;
    }

    return state;
};


/**
 * Highlight the given DOM element as focused.
 * Remove focus from the previously focused item.
 *
 * @param {number} posX - the item horizontal position
 * @param {number} posY - the item vertical position
 *
 * @return {boolean} operation status
 *
 * @fires module:stb/ui/grid~MainPanel#focus:item
 * @fires module:stb/ui/grid~MainPanel#blur:item
 */
Grid.prototype.focusItem = function ( posX, posY ) {
    var $prev = this.$focusItem,
        $prevLine = this.$focusLine,
        $item;

    if ( DEVELOP ) {
        if ( arguments.length !== 2 ) { throw new Error(__filename + ': wrong arguments number'); }
    }

    if ( this.mainList[posY].children.length === 0 ) {

        return false;
    }
    this.$focusLine = this.mainList[posY];

    // different element
    if ( this.$focusLine && this.$focusLine !== $prevLine ) {
        // style
        if ( $prevLine ) {
            $prevLine.classList.remove('focus');
        }

        this.$focusLine.classList.add('focus');
        this.focusY = posY;

        if ( this.$focusLine.children.lenght <= posX ) {
            posX = this.$focusLine.children.lenght - 1;
        }
    }
    if ( this.$focusLine.children.length <= posX ) {
        posX = this.$focusLine.children.length - 1;
    }
    $item = this.$focusLine.children[posX];

    if ( $item && $prev !== $item ) {
        if ( DEVELOP ) {
            if ( !($item instanceof HTMLElement) ) { throw new Error(__filename + ': wrong $item type'); }
        }

        // some item is focused already
        if ( $prev !== null ) {
            if ( DEVELOP ) {
                if ( !($prev instanceof HTMLElement) ) { throw new Error(__filename + ': wrong $prev type'); }
            }

            // style
            $prev.classList.remove('focus');

            // there are some listeners
            if ( this.events['blur:item'] ) {
                this.emit('blur:item', {$item: $prev});
            }
        }

        // draft coordinates
        this.focusX = posX;

        // reassign
        this.$focusItem = $item;

        // correct CSS
        $item.classList.add('focus');

        // there are some listeners
        if ( this.inFocus && this.events['focus:item'] ) {
            this.emit('focus:item', {$prev: $prev, $curr: $item});
        }

        return true;
    }

    // nothing was done
    return false;
};


/**
 * Set item state and appearance as marked.
 *
 * @param {Element} $item - element to focus
 * @param {boolean} state - marked state (true - marked, false - not marked)
 */
Grid.prototype.markItem = function ( $item, state ) {
    if ( DEVELOP ) {
        if ( arguments.length !== 2 ) { throw new Error(__filename + ': wrong arguments number'); }
        if ( !($item instanceof HTMLElement) ) { throw new Error(__filename + ': wrong $item type'); }
        if ( $item.parentNode.parentNode.parentNode.parentNode !== this.$body ) { throw new Error(__filename + ': wrong $item parent element'); }
        if ( Boolean(state) !== state ) { throw new Error(__filename + ': state must be boolean'); }
    }

    // correct CSS
    if ( state ) {
        $item.classList.add('mark');
    } else {
        $item.classList.remove('mark');
    }

    // apply flag
    $item.data.mark = state;
};


// public
module.exports = Grid;
